import axios from "axios";

export const verifyDiscordUsername = async (email, discordUsername) => {
    const accessToken = (window.localStorage.getItem('access_token'));

    const res = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/verify_discord_username?email=${email}&discord_username=${discordUsername}`, [], {
        headers: {
			Authorization: `Bearer ${accessToken}`,
		}
    })).data

    // const res = (await axios.post(`${backendUrl}/preferences?username=${username}&password=${password}&queryName=${queryName}`, queryRowsCopy)).data;
    return true
    // return res;
}